const GlobalAnnouncementBanner = ({ settings }) => {
  const enabled = !!(settings?.globalNoticeEnabled && settings?.globalNoticeMessage);
  if (!enabled) return null;

  const title = settings?.globalNoticeTitle || 'Aviso importante';
  const updatedBy = settings?.globalNoticeUpdatedBy || '';
  const updatedAt = settings?.globalNoticeUpdatedAt || '';

  return (
    <div className="px-4 md:px-6 mt-3">
      <div className="flex items-start gap-3 rounded-xl border border-amber-200 bg-amber-50 text-amber-900 shadow-sm px-4 py-3">
        <div className="mt-1 h-5 w-5 text-amber-600">
          <svg viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5">
            <path d="M12 2a10 10 0 1010 10A10.011 10.011 0 0012 2zm1 15h-2v-2h2zm0-4h-2V7h2z" />
          </svg>
        </div>
        <div className="space-y-1">
          <div className="text-sm font-semibold uppercase tracking-wide">{title}</div>
          <div className="text-sm leading-6 whitespace-pre-wrap">{settings.globalNoticeMessage}</div>
          {(updatedBy || updatedAt) && (
            <div className="text-[11px] text-amber-700">
              {updatedBy && <span>Por: {updatedBy}</span>}
              {updatedBy && updatedAt && <span className="mx-1">•</span>}
              {updatedAt && <span>Actualizado: {updatedAt}</span>}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GlobalAnnouncementBanner;
